'use client';

import Sidebar from '@/components/Sidebar';
import BangDuThao from './components/BangDuThao';

export default function DuThaoPage(props) {
  const { rightBanners, linkPages } = props;

  return (
    <div className="flex flex-col min-h-screen">
      <div className="container mx-auto flex-grow">
        <div className="flex flex-col lg:flex-row gap-6">
          <section className="lg:w-3/4 ">
            <BangDuThao {...props} />
          </section>

          <section className="w-full md:w-1/4 ">
            <Sidebar rightBanners={rightBanners} linkPages={linkPages} websiteCode={props.websiteCode} />
          </section>
        </div>
      </div>
    </div>
  );
}
